import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import * as globals from '../globals';
import { AuthHttp, AuthConfig } from 'angular2-jwt';



@Injectable()
export class RecipesService {

  private recipeUrl = globals.APIURL + '/admin/recipe';
  private recipeProjectUrl = globals.APIURL + '/projects/recipe';
  private templateUrl = this.recipeUrl + '/template';
  private resourceTemplateUrl = this.recipeUrl + '/resourcetemplate';
  private recipeTypeUrl = this.recipeUrl + '/recipetype';
  private recipeMaterialUrl = this.recipeUrl + '/recipematerial';
  private recipeResourceUrl = this.recipeUrl + '/reciperesource';
  private recipeCostingsUrl = this.recipeUrl + '/recipecosting';
  private quoteUrl = globals.APIURL + '/admin/quote';
  private categoryUrl = this.quoteUrl + '/category';
  private resourceUrl = this.quoteUrl + '/resource';
  private materialUrl = globals.APIURL + '/admin/material';
  private projectsUrl = globals.APIURL + '/projects';
  private recipeMaterialUnitUrl = globals.APIURL + '/admin/material/materialunit';
  private recipeMaterialShapeUrl = globals.APIURL + '/admin/material/materialshape';
  private recipeCostingUrl = this.recipeUrl + '/recipecosting';
  private newTamplateFromRecipeUrl = this.recipeUrl + '/template';
  constructor(private http: Http, public authHttp: AuthHttp) { }


  getRecipes(): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let options = new RequestOptions({ body: '', headers: headers });

    return this.authHttp.get(this.recipeUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  addNewRecipeTemplate(templatename: string, templateDesc: any, recipeIdArrays: any): Observable<any> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let body = JSON.stringify({
      template: {
        name: templatename,
        description: templateDesc
      },
      reciperesource_ids: recipeIdArrays
    });

    let options = new RequestOptions({ headers: headers });
    return this.authHttp.post(this.newTamplateFromRecipeUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }


  getRecipesProject(projectid): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let options = new RequestOptions({ body: '', headers: headers });

    return this.authHttp.get(this.recipeProjectUrl + '/' + projectid, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  /**
 * fetch all Resources in MR2 Database
 * @return JSON response body / Error
 */
  getResources(): Observable<string> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ body: '', headers: headers });
    return this.authHttp.get(this.resourceUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getMaterials(): Observable<string> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ body: '', headers: headers });
    return this.authHttp.get(this.materialUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getResourcesCategory(): Observable<string> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ body: '', headers: headers });
    return this.authHttp.get(this.categoryUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }


  getReciperesource(): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let options = new RequestOptions({ body: '', headers: headers });
    return this.authHttp.get(this.recipeResourceUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getRecipecosting(): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let options = new RequestOptions({ body: '', headers: headers });
    return this.authHttp.get(this.recipeCostingsUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  addReciperesource(recipeResource: any, recipe_id: any): Observable<string> {

    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let body = JSON.stringify({
      name: recipeResource.name, description: recipeResource.description,
      recipe_id: recipe_id, resource_id: recipeResource.id,
      category_id: recipeResource.category_id, location_id: recipeResource.location_id
    });

    let options = new RequestOptions({ headers: headers });
    return this.authHttp.post(this.recipeResourceUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  addRecipematerial(recipeMaterials: any, recipeId: number): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let body = JSON.stringify({
      material_id: recipeMaterials.material_id, stock_size_length: recipeMaterials.stock_size_length,
      stock_size_width: recipeMaterials.stock_size_width, stock_size_height: recipeMaterials.stock_size_height,
      materialshape_id: recipeMaterials.materialshape_id, price: recipeMaterials.price, extras: recipeMaterials.extras,
      markup: recipeMaterials.markup, recipe_id: recipeId, materialunits_id: recipeMaterials.materialunits_id
    });

    let options = new RequestOptions({ headers: headers });
    return this.authHttp.post(this.recipeMaterialUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getSpecifiedReciperesource(reciperesourceid: number): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let options = new RequestOptions({ body: '', headers: headers });
    return this.authHttp.get(this.recipeResourceUrl + '/' + reciperesourceid, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getSpecifiedRecipematerial(recipematerialid: number): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let options = new RequestOptions({ body: '', headers: headers });
    return this.authHttp.get(this.recipeMaterialUrl + '/' + recipematerialid, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  updateRecipematerial(recipeMaterials: any): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let body = JSON.stringify({
      material_id: recipeMaterials.material_id, stock_size_length: recipeMaterials.stock_size_length,
      stock_size_width: recipeMaterials.stock_size_width, stock_size_height: recipeMaterials.stock_size_height,
      materialshape_id: recipeMaterials.materialshape_id, price: recipeMaterials.price, extras: recipeMaterials.extras,
      markup: recipeMaterials.markup, cost_each: recipeMaterials.cost_each
    });

    let options = new RequestOptions({ headers: headers });
    return this.authHttp.put(this.recipeMaterialUrl + '/' + recipeMaterials.id, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getSpecifiedResources(resourceid: number): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let options = new RequestOptions({ body: '', headers: headers });
    return this.authHttp.get(this.resourceUrl + '/' + resourceid, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getProjectsBoundingBox(projectid: number): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let options = new RequestOptions({ body: '', headers: headers });
    return this.authHttp.get(this.projectsUrl + '/' + projectid, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getRecipeTemplate(): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let options = new RequestOptions({ body: '', headers: headers });

    return this.authHttp.get(this.templateUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getRecipeMaterial(): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let options = new RequestOptions({ body: '', headers: headers });

    return this.authHttp.get(this.recipeMaterialUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getMaterialUnits(): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let options = new RequestOptions({ body: '', headers: headers });

    return this.authHttp.get(this.recipeMaterialUnitUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getMaterialShapes(): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let options = new RequestOptions({ body: '', headers: headers });

    return this.authHttp.get(this.recipeMaterialShapeUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  getRecipeType(): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let options = new RequestOptions({ body: '', headers: headers });

    return this.authHttp.get(this.recipeTypeUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  addTemplate(): Observable<string> {

    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let options = new RequestOptions({ body: '', headers: headers });

    return this.authHttp.post(this.templateUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  addRecipeCosting(costing: any, recipe_id: any): Observable<string> {
    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let body = JSON.stringify({
      costtype_id: costing.costtype_id, reciperesource_id: costing.resource_id, description: costing.description, costtypeunit_id: costing.costtypeunit_id, rate: costing.rate, burden: costing.burden, activity: costing.burden
    });

    let options = new RequestOptions({ headers: headers });
    return this.authHttp.post(this.recipeCostingUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  addRecipe(recipeValues: any): Observable<string> {

    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let body = JSON.stringify({
      recipe: {
        name: recipeValues.name,
        note: recipeValues.note,
        type_id: recipeValues.type_id,
        template_name: recipeValues.template_name,
        project_id: recipeValues.project_id
      },
      template_id: recipeValues.template_id
    });

    let options = new RequestOptions({ headers: headers });
    return this.authHttp.post(this.recipeUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  updateRecipe(recipeValues: any): Observable<string> {

    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let body = JSON.stringify({
      recipe: {
        name: recipeValues.name,
        is_default: recipeValues.is_default,
        note: recipeValues.note,
        type_id: recipeValues.type_id,
        rating: recipeValues.rating,
        enabled: recipeValues.enabled,
        project_id: recipeValues.project_id,
        nre_cost: recipeValues.nre_cost,
        unit_cost: recipeValues.unit_cost,
        lot_cost: recipeValues.lot_cost,
        material_cost: recipeValues.material_cost,
        total_cost: recipeValues.total_cost
      }
    });

    let options = new RequestOptions({ headers: headers });
    return this.authHttp.put(this.recipeUrl + '/' + recipeValues.id, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }


  updateReciperesource(reciperesourceValues: any, reciperesourceID): Observable<string> {

    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let body = JSON.stringify(reciperesourceValues);

    let options = new RequestOptions({ headers: headers });
    return this.authHttp.put(this.recipeResourceUrl + '/' + reciperesourceID, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }



  updateRecipeCosting(recipeCosting: any): Observable<string> {

    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let body = JSON.stringify({
      description: recipeCosting.description,
      rate: recipeCosting.rate,
      burden: recipeCosting.measure,
      activity: recipeCosting.burden
    });

    let options = new RequestOptions({ headers: headers });
    return this.authHttp.put(this.recipeCostingUrl + '/' + recipeCosting.id, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  removeRecipeResource(recipeResourceId: any): Observable<string> {

    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let options = new RequestOptions({ body: '', headers: headers });

    return this.authHttp.delete(this.recipeResourceUrl + '/' + recipeResourceId, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  removeRecipe(recipeId: any): Observable<string> {

    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let options = new RequestOptions({ body: '', headers: headers });

    return this.authHttp.delete(this.recipeUrl + '/' + recipeId, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  copyRecipe(recipeValues: any): Observable<string> {

    let headers = new Headers({
      'Content-Type': 'application/json'
    });

    let body = JSON.stringify({
      recipe: {
        id: recipeValues.id,
        name: recipeValues.name
      }
    });

    console.log('RECIPE TO COPY INFO:', body);

    let options = new RequestOptions({ headers: headers });
    return this.authHttp.put(this.recipeUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error('CAUGHT AN ERROR:', errMsg); // log to console instead
    return Observable.throw(errMsg);
  }

  private extractData(res: Response) {
    let body = res.json();
    // console.log('BODY:', body);
    return body || {};
  }

}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/recipes/recipes.service.ts